import api from "@/services/api";

export const state = {
  liquidationReasons: [],
  liquidationReason: {},
};

export const mutations = {
  INIT_LIQUIDATION_REASONS(state, payload) {
    state.liquidationReasons = payload;
  },
  INIT_LIQUIDATION_REASON(state, payload) {
    state.liquidationReason = payload;
  },
};

export const actions = {
  getLiquidationReasons({ commit }, payload) {
    return api.getAssociationLiquidationReasons(payload).then((response) => {
        commit("INIT_LIQUIDATION_REASONS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getLiquidationReasonById({ commit }, payload) {
    return api.getAssociationLiquidationReasonById(payload).then((response) => {
      commit("INIT_LIQUIDATION_REASON", response.data.data);
    });
  },
};

export const getters = {
  getLiquidationReasons: (state) => state.liquidationReasons,
  getLiquidationReasonById: (state) => state.liquidationReason,
};
